import { render, staticRenderFns } from "./SuperAdminAvatarCard.vue?vue&type=template&id=47b90ca6&scoped=true&"
import script from "./SuperAdminAvatarCard.vue?vue&type=script&lang=js&"
export * from "./SuperAdminAvatarCard.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminAvatarCard.vue?vue&type=style&index=0&id=47b90ca6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b90ca6",
  null
  
)

export default component.exports